import { render, staticRenderFns } from "./time_yellow_ns.vue?vue&type=template&id=2d81c77e&scoped=true"
import script from "./time_yellow_ns.vue?vue&type=script&lang=js"
export * from "./time_yellow_ns.vue?vue&type=script&lang=js"
import style0 from "./time_yellow_ns.vue?vue&type=style&index=0&id=2d81c77e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d81c77e",
  null
  
)

export default component.exports